import { Observable } from "rxjs";

import st from "lib/utils/index";
import { CustomerDecorator } from "lib/decorators/index";
import { CustomersRepository } from "lib/repositories/index";
import { pushRoute } from "modules/app/actions";
import { createResourceInstance, createFormInstance } from "modules/utils/index";

export const OPEN = "customers/EditCustomerModal/OPEN";
export const CLOSE = "customers/EditCustomerModal/CLOSE";

export const LOAD_CUSTOMER = "customers/EditCustomerModal/LOAD_CUSTOMER";
export const FETCH_CUSTOMER = "customers/EditCustomerModal/FETCH_CUSTOMER";
export const FETCH_CUSTOMER_START = "customers/EditCustomerModal/FETCH_CUSTOMER_START";
export const FETCH_CUSTOMER_SUCCESS = "customers/EditCustomerModal/FETCH_CUSTOMER_SUCCESS";
export const FETCH_CUSTOMER_FAILURE = "customers/EditCustomerModal/FETCH_CUSTOMER_FAILURE";

export const INITIALIZE_MODEL = "customers/EditCustomerModal/INITIALIZE_MODEL";
export const UPDATE_MODEL = "customers/EditCustomerModal/UPDATE_MODEL";
export const VALIDATE = "customers/EditCustomerModal/VALIDATE";
export const SUBMIT = "customers/EditCustomerModal/SUBMIT";
export const FETCH_SUBMIT_START = "customers/EditCustomerModal/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "customers/EditCustomerModal/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "customers/EditCustomerModal/FETCH_SUBMIT_FAILURE";

export const REMOVE = "customers/EditCustomerModal/REMOVE";
export const FETCH_REMOVE_START = "customers/EditCustomerModal/FETCH_REMOVE_START";
export const FETCH_REMOVE_SUCCESS = "customers/EditCustomerModal/FETCH_REMOVE_SUCCESS";
export const FETCH_REMOVE_FAILURE = "customers/EditCustomerModal/FETCH_REMOVE_FAILURE";

export const stateSelector = (state) => state.customers.EditCustomerModal;

const resourceInstance = createResourceInstance({
  LOAD: LOAD_CUSTOMER,
  FETCH: FETCH_CUSTOMER,
  FETCH_START: FETCH_CUSTOMER_START,
  FETCH_SUCCESS: FETCH_CUSTOMER_SUCCESS,
  FETCH_FAILURE: FETCH_CUSTOMER_FAILURE,
  stateSelector,
  stateKey: "customer",
  getModel: ({ customerId }) => {
    return CustomersRepository.find(customerId);
  },
});

const removeResourceInstance = createResourceInstance({
  FETCH: REMOVE,
  FETCH_START: FETCH_REMOVE_START,
  FETCH_SUCCESS: FETCH_REMOVE_SUCCESS,
  FETCH_FAILURE: FETCH_REMOVE_FAILURE,
  stateSelector,
  stateKey: "removal",
  getModel: ({ customerId }) => {
    if (!customerId) {
      return Observable.empty();
    }
    return CustomersRepository.delete(customerId);
  },
});

const formInstance = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  validate: ({ form: { model: customer } }, errors, { submitValidate }) => {
    errors.add(`customer.full_name`, st.validators.presence(customer.full_name));
    errors.add(`customer.full_name`, st.validators.length(customer.full_name, { minimum: 5, maximum: 100 }));
  },
  submitModel: ({ form: { model } }) => {
    return model.id ? CustomersRepository.update(model) : CustomersRepository.create(model);
  },
});

const initialState = {
  opened: false,
  customerId: null,
  customer: resourceInstance.initialState,
  form: formInstance.initialState,
  removal: removeResourceInstance.initialState,
};

const reducers = {
  ...resourceInstance.reducersMap,
  ...formInstance.reducersMap,
  ...removeResourceInstance.reducersMap,

  [OPEN]: (state, { customer }) => ({
    ...initialState,
    opened: true,
    customerId: customer.id,
  }),

  [CLOSE]: (state) => ({
    ...state,
    opened: false,
  }),
};

const epics = [
  ...resourceInstance.epics,
  ...formInstance.epics,
  ...removeResourceInstance.epics,

  (actions$) =>
    actions$
      .ofType(LOAD_CUSTOMER)
      .merge(actions$.ofType(FETCH_CUSTOMER_SUCCESS))
      .map(({ model }) => {
        return initializeModel(model);
      }),

  (actions$) => actions$.ofType(FETCH_SUBMIT_SUCCESS).merge(actions$.ofType(FETCH_REMOVE_SUCCESS)).mapTo(close()),
];

export const { initializeModel, updateModel: updateCustomer, validate, submit } = formInstance.actions;
export const { load: loadCustomer, fetch: fetchCustomer } = resourceInstance.actions;
export const { fetch: removeCustomer } = removeResourceInstance.actions;

export function open(customer) {
  if (customer === undefined) {
    customer = CustomerDecorator.build();
  }

  return (dispatch, getState) => {
    const { opened, customerId } = stateSelector(getState());
    if (!(opened && customerId === customer.id)) {
      dispatch({ type: OPEN, customer });
      if (customer.id && !customer.type) {
        dispatch(fetchCustomer());
      } else {
        dispatch(loadCustomer(customer));
      }
    }

    const location = getState().app.location;
    if (location.query.editCustomer != customer.id) {
      dispatch(
        pushRoute({
          ...location,
          query: {
            ...location.query,
            editCustomer: customer.id,
          },
        })
      );
    }
  };
}

export function close() {
  return (dispatch, getState) => {
    const { opened } = stateSelector(getState());
    if (opened) {
      dispatch({ type: CLOSE });
    }

    const location = getState().app.location;
    if (location.query.editCustomer) {
      dispatch(
        pushRoute({
          ...location,
          query: {
            ...location.query,
            editCustomer: undefined,
          },
        })
      );
    }
  };
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/customers/EditCustomerModal/index.js